import React, {useState} from 'react';
import PropTypes from 'prop-types';
import './title.css';

const Title = (props) => {

  const [instanceInput, updateInstanceInput] = useState('');

  const {
    addToMonitoring,
    instances,
    preferences,
    refresh,
    removeAllFromMonitoring,
    updateScreenShotViewerState,
  } = props;

  // Add an instance to monitoring when the enter key is pressed while focused on the input box.
  const handleEnterPress = e => {
    if (e.keyCode === 13) handleAddToMonitoring();
  };

  // If a valid instance is entered add it to monitoring.
  const handleAddToMonitoring = () => {
    if (/ - /.test(instanceInput)) {
      let newInstance = instances.find(instance => {
        return instance.InstanceId === instanceInput.match(/(.+?) - /)[1];
      });
      if (newInstance) addToMonitoring(newInstance);
    } else {
      let newInstance = instances.find(instance => {
        return instance.InstanceId === instanceInput || instance.name === instanceInput;
      });
      if (newInstance) addToMonitoring(newInstance);
    }
    updateInstanceInput('');
  };

  // Invert the screenshot panning controls
  const handleInvertNavControls = e => {
    const newPreferences = {...preferences};
    newPreferences.invertNavControls = e.target.checked;
    updateScreenShotViewerState({newPreferences});
  };

  // Update the default refresh rate.
  const handleDefaultRefreshRate = e => {
    let refreshRate = parseInt(e.target.value, 10);
    if (!isNaN(refreshRate)) {
      const newPreferences = {...preferences};
      newPreferences.defaultRefreshRate = refreshRate < 5 ? 5 : refreshRate;
      updateScreenShotViewerState({preferences: newPreferences});
    }
  };

  return (
    <div className="Title">
      <h1>EC2 Instance Screenshot Viewer</h1>
      <div className="InputMonitor">
        <p>Instance To Monitor:</p>
        <input
          list="instances"
          name="instance"
          value={instanceInput}
          onChange={e => updateInstanceInput(e.target.value)}
          onKeyDown={handleEnterPress}
          placeholder="Search..."
        />
        <datalist id="instances">
          {instances.map(instance => {
            return <option key={`option-${instance.InstanceId}`} value={`${instance.InstanceId} - ${instance.name} - ${instance.accountName}`}></option>;
          })}
        </datalist>
        <button onClick={handleAddToMonitoring}>Monitor</button>
      </div>
      <button className="RemoveAllButton" onClick={removeAllFromMonitoring}>Remove All</button>
      <button className="RemoveAllButton" onClick={refresh}>Refresh</button>
      <div className="PreferencesPanel">
        <h3>Preferences</h3>
        <div>
          <label htmlFor="defaultRefreshTime">Default Refresh Time:</label>
          <input id="defaultRefreshTime" name="defaultRefreshTime" value={preferences.defaultRefreshRate} onChange={handleDefaultRefreshRate}/>
        </div>
        <div>
          <label htmlFor="InvertNavControls">Invert Navigation Controls:</label>
          <input id="InvertNavControls" name="InvertNavControls" type="checkbox" checked={preferences.invertNavControls} onChange={handleInvertNavControls}/>
        </div>
      </div>
    </div>
  );

};

Title.propTypes = {

};

export default Title;


// WEBPACK FOOTER //
// ./src/components/content/instanceScreenshotViewer/title/title.js